import React from 'react'
import { Button } from 'react-bootstrap';

function Buttoncom(props) {
    const {event,className,disabled,text,style,variant} = props
    
    return ( <>
        <Button onClick = {event}
            className = {className}
            disabled = {disabled}
            style = {style}
            variant = {variant}
        >
            {text}
        </Button>
    
    </> );
}

export default Buttoncom;
